export enum CookieKeys {
    tenantRoute = "sbc-tenantRoute",
    isOperator = "sbc-isOperator",
    isStatsDashboard = "sbc-isStatsDashboard",
    isBriefcaseFeedback = "sbc-isBriefcaseFeedback",
}
